import { Customer } from '../../../models/customer';
import { customersApiKeyStore } from '../../../api/customers-api-key-store';
import { SiTrackPage } from '../../../components/si-track-page';
import { useParams } from 'react-router';
import { SaveCustomerComponent } from './save-customer.component';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';

export const EditCustomerPage = () => {
  const { id } = useParams();
  const { isLoading, data } = useLoadData<ApiResponse<Customer>>(customersApiKeyStore.getCustomer(id));

  return (
    <SiTrackPage title="Edit Customer" isLoading={isLoading}>
      {data && <SaveCustomerComponent customer={data.data} onEdit />}
    </SiTrackPage>
  );
};
